import { HttpClient } from '@angular/common/http';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Inject,
  OnDestroy,
  OnInit,
} from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { finalize, Subject, takeUntil } from 'rxjs';
import { environment } from 'src/environments/environment';
import { NotificationService } from 'src/shared/notification.service';

const OUTFLOW_EVIDENCE_ENDPOINT = `${environment.alimentosBebidasApi}/api/v1`;

@Component({
  selector: 'app-dialog-confirm',
  templateUrl: './dialog-confirm.component.html',
  styleUrls: ['./dialog-confirm.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DialogConfirmationComponent implements OnInit, OnDestroy {
  private _unsubscribeOnDestroy$: Subject<boolean> = new Subject<boolean>();
  isRemovingEvidence = false;
  deletedSuccessfully = false;
  hasDocument = false;

  constructor(
    public dialogRef: MatDialogRef<DialogConfirmationComponent>,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA)
    public dialogData: {
      hasDocument: boolean;
      outflowId: string;
      evidenceKey: string;
    },
    private readonly httpClient: HttpClient,
    private readonly notificationService: NotificationService,
    private readonly cdRef: ChangeDetectorRef,
  ) {
    this.hasDocument = dialogData.hasDocument;
  }

  ngOnInit(): void {}

  ngOnDestroy(): void {
    this._unsubscribeOnDestroy$.next(true);
    this.onClose();
  }

  removeEvidence() {
    if (this.isRemovingEvidence) {
      return;
    }
    this.isRemovingEvidence = true;
    this.httpClient
      .delete<{
        hasEvidence: boolean;
        deletedSuccessfully: boolean;
      }>(
        `${OUTFLOW_EVIDENCE_ENDPOINT}/delete-evidence/${this.dialogData.evidenceKey}`,
      )
      .pipe(
        takeUntil(this._unsubscribeOnDestroy$),
        finalize(() => {
          this.isRemovingEvidence = false;
          this.cdRef.markForCheck();
        }),
      )
      .subscribe({
        next: ({ deletedSuccessfully, hasEvidence }) => {
          if (!deletedSuccessfully) {
            this.notificationService.notifyError(
              'No se pudo eliminar la evidencia. Por favor, notificar este error.',
            );
            return;
          }

          this.deletedSuccessfully = deletedSuccessfully;
          this.hasDocument = hasEvidence;

          this.notificationService.showSuccessAlert(
            'Evidencia eliminada correctamente',
            () => {
              this.dialogRef.close({
                deletedSuccessfully: this.deletedSuccessfully,
                hasDocument: this.hasDocument,
              });
            },
          );
        },
        error: (error: any) => {
          console.error('Error removing evidence:', error);
          this.deletedSuccessfully = false;
          this.notificationService.notifyError(
            'Error al eliminar la evidencia. Por favor, notificar este error.',
          );
        },
      });
  }

  onClose() {
    this.dialogRef.close({
      deletedSuccessfully: this.deletedSuccessfully,
      hasDocument: this.hasDocument,
    });
  }
}
